import { useEffect, useSyncExternalStore } from "react";

// Maps whose navigation column sits in the bottom-right corner, where the
// toasts appear on larger screens.
let mapControlsShown = 0;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function notify() {
  listeners.forEach((listener) => listener());
}

/** While ``active``, toasts open left of a map's bottom-right controls. */
export function useToastsClearOfMapControls(active: boolean) {
  useEffect(() => {
    if (!active) return;
    mapControlsShown += 1;
    notify();
    return () => {
      mapControlsShown -= 1;
      notify();
    };
  }, [active]);
}

/** Whether a mounted map asked the toasts to keep clear of its controls. */
export function useToastsClearOfMap(): boolean {
  return useSyncExternalStore(subscribe, () => mapControlsShown > 0);
}
